/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/shelfList.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_SHELF_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { capitalCase } from "change-case";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IShelfListMethods extends IPluginMethodMap {
  getShelfList(args: any): Promise<any>;
}

export class ShelfListService implements IAgentPlugin {
  readonly methods: IShelfListMethods;

  constructor() {
    this.methods = {
      getShelfList: this.getShelfList.bind(this),
    };
  }

  async getShelfList(args: any) {
    log.blue(`getShelfList server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.query({
          query: GET_SHELF_LIST,
          variables: {
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
            filter: {
              ...args?.criteria,
              band__in:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
            distFilter: {
              band__in:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          let _totalPages = res?.data?.getShelves?.count
            ? parseInt(res?.data?.getShelves?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getShelves?.skip / res?.data?.getShelves?.limit + 1;
          return {
            ...config,
            band: {
              name:
                storageService.get("bandConfig", "local")?.band?.appCardTitle ??
                null,
              id:
                storageService.get("bandConfig", "local")?.band?.appCardId ??
                null,
            },
            isEmpty: res?.data?.getShelves?.content?.length <= 0,
            ultUsers: this._getSehlfData(res?.data?.getShelves?.content),
            activePage: _currentPage,
            pageSize: res?.data?.getShelves?.limit,
            totalCount: res?.data?.getShelves?.count,
            totalPages: _totalPages,
            distCenters: this._getDistCenters(res?.data?.getDistCents?.content),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private _getSehlfData = (data: any) => {
    let _res: any[] = [];
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any, index: number) => {
        _res.push({
          id: item?.id,
          shelfId: item?.shelfId,
          name: item?.name,
          activeStatus: item?.activeStatus,
          //filter boxes which are not Delivered
          boxesCount:
            item?.boxes && Array.isArray(item?.boxes)
              ? item.boxes.filter(
                  (box: any) =>
                    box?.deliveryStatus.toLowerCase() !== "delivered"
                ).length
              : "0",
          distName: item?.distCent?.name,
          deliveryStatus: item?.shelfDeliveryStatus,
          dateCreated: item?.createdAt
            ? this.formatCreatedDate(item?.createdAt)
            : "",
        });
      });
    console.log(`_getSehlfData : `, _res);
    return _res;
  };

  private _getDistCenters = (data: any) => {
    let _res: any = [];
    if (data && Array.isArray(data) && data.length > 0) {
      if (data.length > 1) {
        _res.push({
          label: "Select",
          value: "null",
          key: 0,
        });
      }
      data.map((item: any, index: number) => {
        _res.push({
          label: item?.name ? capitalCase(item?.name) : item?.distCenterId,
          value: item?.id,
          key: index + 1,
        });
      });
    }
    return _res;
  };

  private formatCreatedDate(date: Date) {
    const metaData = storageService.get("bandConfig", "local")?.metaData;
    console.log(`metaData`, metaData);
    if (date && metaData) {
      let _date = `${moment.tz(date, metaData?.tmz).format("LLL")} ${
        metaData?.abbrevation
      }`;
      console.log(`_date`, _date);
      return _date;
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "INVITED":
          return "invited";
        case "EMAIL_VERIFIED":
          return "verified";
        case "ACC_CREATED":
          return "active";
        case "WALLET_REGISTERED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
